import useSWR, { type SWRConfiguration } from 'swr';
import useOwnerOrgId from '@/lib/hooks/useOwnerOrgId';
import fetcherWithDataKey from '@/lib/swr/fetcherWithDataKey';
import type OpportunitySummary from '@/types/api/OpportunitySummary';
import joinNonEmptyParams from '@/utils/joinNonEmptyParams';

export default function useOpportunitySummary(
  params: Record<string, unknown> = {},
  swrOptions?: SWRConfiguration,
) {
  const ownerOrgId = useOwnerOrgId();
  return useSWR(
    ownerOrgId
      ? `reporting/${ownerOrgId}/opportunities?${joinNonEmptyParams({
          moduleName: 'opportunities-summary',
          ...params,
        })}`
      : null,
    fetcherWithDataKey<OpportunitySummary>('report'),
    swrOptions,
  );
}
